<template>
  <section id="carousel" class="pt-12">
    <v-container fluid>
      <div
        class="container--content d-lg-flex align-center justify-space-around"
      >
        <v-btn
          v-if="$vuetify.breakpoint.lgAndUp"
          fab
          :class="{ 'v-box-shadow': prevDisabled }"
          color="transparent"
          @click="prevSlide"
          :disabled="prevDisabled"
        >
          <v-icon :color="!prevDisabled ? 'grey darken-1' : ''"
            >mdi-arrow-right</v-icon
          >
        </v-btn>
        <div class="slider-wrapper custom-slider">
          <v-slide-group
            mandatory
            v-model="slider"
            center-active
            :show-arrows="false"
            @change="checkSliderModel"
          >
            <v-slide-item
              v-for="(item, itemInd) in opinions"
              :key="itemInd"
              v-slot="{ active, toggle }"
            >
              <CarouselItem :item="item" :options="{ active, toggle }" />
            </v-slide-item>
          </v-slide-group>
        </div>
        <v-btn
          fab
          v-if="$vuetify.breakpoint.lgAndUp"
          :class="{ 'v-box-shadow': nextDisabled }"
          @click="nextSlide"
          :disabled="nextDisabled"
          color="transparent"
        >
          <v-icon :color="!nextDisabled ? 'grey darken-1' : ''"
            >mdi-arrow-left</v-icon
          >
        </v-btn>
      </div>
      <div
        class="
          custom-pagination
          px-5 px-sm-0
          mt-6
          mx-auto
          rounded-lg
          d-flex
          align-center
          justify-center
        "
      >
        <div
          class="box-pag rounded-lg cursor-pointer"
          :class="[
            { primary: n == activeSlide },
            { primary: n == 4 && activeSlide == 5 },
            { primary: n == 1 && activeSlide == 0 },
          ]"
          v-for="n in items.length - 2"
          @click="getSlider(n)"
          :key="n"
        />
      </div>
    </v-container>
  </section>
</template>

<script>
import CarouselItem from "./ESayCarouselItem.vue";
export default {
  data: () => ({
    slider: 1,
    activeSlide: 1,
    items: [
      {
        img: "avatar-1",
        personName: "عائشة السديري",
        country: "المملكة العربية السعودية",
        text: "كنت دائمًا أتداول بناءً على اطلاعي على أخبار العالم وأحداثه. ومع ذلك، منذ أن تعلمت التحليل الفني وكيفية قراءة المخططات البيانية بشكل صحيح، قمت بفتح صفقات ناجحة لم أكن أحلم بها من قبل ",
      },
      {
        img: "avatar-2",
        personName: "هيثم التميمي",
        country: "الامارات",
        text: "كانت الثقة تشكل عقبة أمامي دائمًا في التداول. وكثيرًا ما كنت أحاول أن اتمالك أعصابي أثناء التداول. التعلُّم عن الجانب النفسي في التداول منحني الثقة التي أحتاجها لتحقيق النتائج التي أرغب بها في نهاية الأمر. ",
      },
      {
        img: "avatar-3",
        personName: "احمد ابو العينين ",
        country: "مملكة البحرين",
        text: "لقد تعلمت من تريدرز أكاديمي أسس كيفية التداول. ربما يكون الدخول إلى الأسواق دون أي معرفة أمرًا مرعبًا، لكن دورة أسس التداول سمحت لي بفتح أولى صفقاتي الرابحة بكل ثقة. ",
      },
      {
        img: "avatar-4",
        personName: "سميرة الهندي",
        country: "قطر",
        text: "لم أتداول الفوركس من قبل، ولكن منذ أن استعنت بتريدرز أكاديمي، اجتزت دورات تدريبية في تداول الأسهم والسلع وأشعر أن لدي المعرفة أخيرًا لدخول هذه الأسواق. ",
      },
      {
        img: "avatar-1",
        personName: "عائشة السديري",
        country: "المملكة العربية السعودية",
        text: "كنت دائمًا أتداول بناءً على اطلاعي على أخبار العالم وأحداثه. ومع ذلك، منذ أن تعلمت التحليل الفني وكيفية قراءة المخططات البيانية بشكل صحيح، قمت بفتح صفقات ناجحة لم أكن أحلم بها من قبل ",
      },
      {
        img: "avatar-2",
        personName: "هيثم التميمي",
        country: "الامارات",
        text: "كانت الثقة تشكل عقبة أمامي دائمًا في التداول. وكثيرًا ما كنت أحاول أن اتمالك أعصابي أثناء التداول. التعلُّم عن الجانب النفسي في التداول منحني الثقة التي أحتاجها لتحقيق النتائج التي أرغب بها في نهاية الأمر. ",
      },
    ],
    opinions: [
      {
        name: "محمد التهامي",
        title: "شركه محترمة ولها سابقة اعمال تحترم",
      },
      {
        name: "محمود جريشة",
        title: "شركة محترمه اوصي التعامل معها",
      },
      {
        name: "محمد حسين النبوي",
        title: "شركة جودة العمل جيدة ولها سابقة اعمال محترمة",
      },
      {
        name: "محمد علي",
        title: "شغل تمام الله ينور",
      },
      {
        name: "علي عبد الحكيم علي بن سيف",
        title: "شركة محترمة جدا عندها مصداقية",
      },
      {
        name: "محمد التهامي",
        title: "شركة محترمه اوصي التعامل معها",
      },
    ],
  }),
  methods: {
    getSlider(index) {
      this.activeSlide = index;
      this.slider = this.activeSlide;
    },
    checkSliderModel() {
      this.activeSlide = this.slider;
    },
    nextSlide() {
      if (this.nextDisabled) return;
      this.slider++;
      this.activeSlide = this.slider;
    },
    prevSlide() {
      if (this.prevDisabled) return;
      this.slider--;
      this.activeSlide = this.slider;
    },
  },
  computed: {
    prevDisabled() {
      return this.slider <= 1;
    },
    nextDisabled() {
      return this.slider >= this.items.length - 2;
    },
  },
  components: {
    CarouselItem,
  },
};
</script>
<style lang="scss" scoped>
@import "~vuetify/src/styles/styles.sass";
.custom-pagination {
  background: #eeeeee 0% 0% no-repeat padding-box;
  // #EEEEEE 0% 0% no-repeat padding-box
  box-shadow: inset 0px 3px 6px #00000029;
  max-width: 360px;
  .box-pag {
    height: 12px;
    width: 100%;
  }
}
.slider-wrapper {
  // width: 90%;
  @media #{map-get($display-breakpoints,"lg-and-up")} {
    width: 80%;
  }
}
@media #{map-get($display-breakpoints,"lg-and-up")} {
  .container--content {
    gap: 30px;
  }
}
</style>
